<template>
	<div style="width: 100%;">
		<div
			style="width: 210px;padding-top: 9px;padding-bottom: 9px;font-size: 14px;margin: auto;text-align: center;background-color: #aaa7a7;border-radius: 10px 10px 0px 0px;border-bottom: solid 1px #c6c6c6;">
			{{selectdItem.compontChildren[0].name + '设置'}}
		</div>
		<div class="item">
			<div>分类设置</div>
		</div>

		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">左侧栏显示</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.classFiyConfig.left.show = true"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.classFiyConfig.left.show?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.classFiyConfig.left.show?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.classFiyConfig.left.show?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">是</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.classFiyConfig.left.show = false"
					:style="{backgroundColor: !selectdItem.compontChildren[0].layoutConfig.classFiyConfig.left.show?'#8c62ff':'#fff',color: !selectdItem.compontChildren[0].layoutConfig.classFiyConfig.left.show?'#fff':'#000',border: !selectdItem.compontChildren[0].layoutConfig.classFiyConfig.left.show?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">否</span>
				</div>
			</div>
		</div>

		<div style="margin-left: 6px;">分类主题设置</div>
		<div class="item">
			<el-select size="mini" style="width: 100px;"
				v-model="selectdItem.compontChildren[0].layoutConfig.classFiyConfig.font.classFiySzieFamily"
				placeholder="选择字体">
				<el-option v-for="(fontItem,index) in fontList" :key="index" :label="fontItem.code"
					:value="fontItem.name">
				</el-option>
			</el-select>
			<el-color-picker size="mini"
				v-model="selectdItem.compontChildren[0].layoutConfig.classFiyConfig.font.classFiyColor"
				style="margin-left: 3px;"></el-color-picker>
			<div style="border: solid 1px #cccccc ;display: flex;align-items: center;padding: 2px;margin-left: 3px;">
				<wm-input-number style="margin-left: 10px;" :iptWidth="30" :disabled="false"
					:styleObj="{width: '30',height: '24px'}" :step="1" :min="1" :max="10000000000"
					:value="selectdItem.compontChildren[0].layoutConfig.classFiyConfig.font.classFiySzie"
					@change="(e)=>{selectdItem.compontChildren[0].layoutConfig.classFiyConfig.font.classFiySzie = e}"></wm-input-number>
			</div>
		</div>
		
		<div class="item">
			<div>标题颜色</div>
			<el-color-picker size="mini" style="height: 32px;width: 32px;margin-top: 4px;"
				v-model="selectdItem.compontChildren[0].layoutConfig.classFiyConfig.titleColor"></el-color-picker>
		</div>
		
		<div class="item">
			<div>价格滑块颜色</div>
			<el-color-picker size="mini" style="height: 32px;width: 32px;margin-top: 4px;"
				v-model="selectdItem.compontChildren[0].layoutConfig.classFiyConfig.priceSliderColor"></el-color-picker>
		</div>
		
		<div class="item">
			<div>选中颜色</div>
			<el-color-picker size="mini" style="height: 32px;width: 32px;margin-top: 4px;"
				v-model="selectdItem.compontChildren[0].layoutConfig.classFiyConfig.font.classFiySelectdColor"></el-color-picker>
		</div>

		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">组件边框</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.type = ''"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.type == ''?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.type == ''?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.type == ''?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">无</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.type = 'solid'"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.type == 'solid'?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.type == 'solid'?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.type== 'solid'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">实线</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.type = 'dashed'"
					:style="{backgroundColor:selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.type == 'dashed'?'#8c62ff':'#fff',color:selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.type == 'dashed'?'#fff':'#000',border:selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.type == 'dashed'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">虚线</span>
				</div>
			</div>
		</div>


		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">边框颜色</div>
			<el-color-picker size="mini" style="height: 34px;width: 34px;"
				v-model="selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.color"></el-color-picker>
			<el-input size="mini" style="height: 34px;width: 82px;" disabled
				:value="selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.color"></el-input>
		</div>
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;">
			<div v-if="selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.borderSize"
				style="margin-top: 10px;">
				<div>线条大小</div>
				<div
					style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px;">
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerSize"
							v-model="selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.borderSize[0]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">顶部</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerSize"
							v-model="selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.borderSize[1]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">左侧</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerSize"
							v-model="selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.borderSize[2]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">底部</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerSize"
							v-model="selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.borderSize[3]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">右侧</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;margin-left: 4px;">
						<i @click="borderContainerSizeAll = !borderContainerSizeAll"
							:style="{color:borderContainerSizeAll?'#8c62ff':'#000'}"
							style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
							class="el-icon-paperclip tit-icon"></i>
					</div>
				</div>
			</div>

		</div>
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;">
			<div style="margin-top: 10px;"
				v-if="selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.borderRadius">
				<div>边框圆角</div>
				<div
					style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px 0px 6px 6px;">
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerBorderRadius"
							v-model="selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.borderRadius[0]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">左上</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerBorderRadius"
							v-model="selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.borderRadius[1]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">右上</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerBorderRadius"
							v-model="selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.borderRadius[2]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top:2px;">右下</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerBorderRadius"
							v-model="selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.borderRadius[3]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">左下</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;margin-left: 4px;">
						<i @click="borderContainerRadiusAll = !borderContainerRadiusAll"
							:style="{color:borderContainerRadiusAll?'#8c62ff':'#000'}"
							style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
							class="el-icon-paperclip tit-icon"></i>
					</div>
				</div>
			</div>
		</div>
		
		<div class="item">
			<div>分页器选中颜色</div>
			<el-color-picker size="mini" style="height: 32px;width: 32px;margin-top: 4px;"
				v-model="selectdItem.compontChildren[0].layoutConfig.classFiyConfig.paginationSelectColor"></el-color-picker>
		</div>
		<div class="item">
			<div>分页器悬停颜色</div>
			<el-color-picker size="mini" style="height: 32px;width: 32px;margin-top: 4px;"
				v-model="selectdItem.compontChildren[0].layoutConfig.classFiyConfig.paginationHoverColor"></el-color-picker>
		</div>




		<div style="width: 100%;height: 1px;background-color: #c7c7c7;margin: 8px 0px;">
		</div>
		<goods-tool :fontFamilyName="systemFontFamilyName" v-bind="$props"></goods-tool>
	</div>
</template>

<script>
	import wmInputNumber from '../components/inputNumber.vue'
	import goodsTool from './goodsTool.vue'
	export default {
		components: {
			goodsTool,
			wmInputNumber
		},
		props: {
			all_setting: {
				type: Array,
				default: []
			},
			fontList: {
				type: Array,
				default: []
			},
			equipment: {
				type: String,
				default: "pc"
			},
			compontentStyle: {
				type: Object,
				default: () => {
					return {}
				}
			},
			systemConfig: {
				type: Object,
				default: () => {
					return {}
				}
			},
			selectdItem: {
				type: Object,
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				fontFamily: "",
				borderContainerRadiusAll: true,
				borderContainerSizeAll: true,
			}
		},
		computed: {
			systemFontFamilyName: function() {
				if (this.all_setting.length > 0) {
					return this.all_setting[0].tabList[1].config.setfontFamily.name
				} else {
					return ''
				}
			}
		},
		mounted() {
			let font = this.selectdItem.compontChildren[0].layoutConfig.classFiyConfig.font
			font.classFiySzieFamily = font.classFiySzieFamily ? font.classFiySzieFamily : this.systemFontFamilyName

		},
		methods: {
			changeContainerBorderRadius(e) {
				if (this.borderContainerRadiusAll) {
					this.selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.borderRadius = []
					this.selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.borderRadius.push(e.target.value)
					this.selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.borderRadius.push(e.target.value)
					this.selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.borderRadius.push(e.target.value)
					this.selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.borderRadius.push(e.target.value)
				}
			},
			changeContainerSize(e) {
				if (this.borderContainerSizeAll) {
					this.selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.borderSize = []
					this.selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.borderSize.push(e.target.value)
					this.selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.borderSize.push(e.target.value)
					this.selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.borderSize.push(e.target.value)
					this.selectdItem.compontChildren[0].layoutConfig.classFiyConfig.border.borderSize.push(e.target.value)
				}
			},
		}
	}
</script>

<style scoped>
	.item {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin: 6px;
	}
	input:focus {
		outline: none;
		border: 1px solid #242754;
		border-radius: 3px;
	}
	
	input {
		outline: none;
		border: 1px solid #c1c1c1;
		border-radius: 5px;
	}
</style>